<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{
                                $t("inicio")
                                }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'integraciones' }">{{
                                $t("integraciones")
                                }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ $t("productosNoRelacionados") }}
                        </li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>
                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="cambioBusiness(), idTpv = -1, idsTPV = []"
                                    :placeholder="$t('seleccionaNegocio')">

                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName" :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listTPV"><strong>{{ $t("TPV") }}</strong></label>
                                <el-select class="select-default" size="large" v-model="idTpv" filterable
                                    @change="tabs == 'Productos' ? getProducts(0) : getSubproducts(0)"
                                    :placeholder="$t('seleccionaTpv')">

                                    <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id"
                                        :label="tpv.nameShow" :key="tpv.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="configTpv">
                <vue-tabs class="col-md-12" @tab-change="handleTabChange" v-model="tabs">
                    <v-tab title="" :disabled="true"></v-tab>
                    <v-tab title="Productos">
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <div class="input-group" style="margin-top:20px; margin-bottom: 20px;">
                                    <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                        v-model="searchQuery2" @keyup.enter.prevent="searchProducts" />
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" type="button" @click="searchProducts">
                                            <i class="fa fa-search"></i>
                                        </button>
                                        <button class="btn btn-secondary" type="button" @click="removeSearchProduct">
                                            <i class="fa fa-times"></i>
                                        </button>

                                    </div>
                                </div>
                                <div v-if="listProducts.length > 0" class="text-left">
                                    <button @click="showReplaceConfirmation(0)" class="btn btn-primary mt-3 mb-2" >
                                        <i class="fas fa-save"></i> &nbsp; {{ $t("generarPlu") }}
                                    </button>
                                </div>
                            </div>

                            <div v-if= "listProducts.length > 0" class="col-md-12 mt-2">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped text-nowrap">
                                        <thead class="thead-dark">
                                            <tr style="cursor: pointer">
                                                <th><i style="color: white"></i> {{ $t("nombre") }}</th>
                                                <th><i style="color: white"></i> {{ $t("precio") }}</th>
                                                <th><i style="color: white"></i>PLU</th>
                                                <th><i style="color: white"></i> {{ $t("acciones") }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(obj, index) in listProducts">
                                                <td v-if="obj.nameprice.trim() !== ''">
                                                    {{ obj.name.trim() + " [" + obj.nameprice.trim() + "]" }}
                                                </td>
                                                <td v-else>{{ obj.name.trim() }}</td>

                                                <td>{{ obj.price | currency }}</td>
                                                <td width="20%">
                                                    <input class="form-control" type="text" v-model="obj.newPLU" />
                                                </td>
                                                <td align="center">
                                                    <button v-if="obj.PLU == obj.newPLU" class="btn btn-primary">
                                                        <i class="fa-solid fa-floppy-disk"></i>
                                                    </button>
                                                    <button v-else class="btn btn-warning" @click="changedPLU(obj, 0)">
                                                        <i class="fa-solid fa-floppy-disk"></i>
                                                    </button>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else class="alert alert-danger m-3" style="width: 100%" role="alert">
                                No se encontraron productos sin PLU. Todos los productos están configurados correctamente.
                            </div>
                        </div>
                    </v-tab>
                    <v-tab title="Materias Primas">
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <div class="input-group" style="margin-top:20px; margin-bottom: 20px;">
                                    <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                        v-model="searchQuery" @keyup.enter.prevent="searchSubproducts" />
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" type="button" @click="searchSubproducts">
                                            <i class="fa fa-search"></i>
                                        </button>
                                        <button class="btn btn-secondary" type="button" @click="removeSearchSubProduct">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>

                                </div>
                                <div v-if="listSubproducts.length > 0" class="text-left">
                                    <button @click="showReplaceConfirmation(1)" class="btn btn-primary mt-3 mb-2" >
                                        <i class="fas fa-save"></i> &nbsp; {{ $t("generarPlu") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if= "listSubproducts.length > 0" class="col-md-12 mt-2">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped text-nowrap">
                                        <thead class="thead-dark">
                                            <tr style="cursor: pointer">
                                                <th><i style="color: white"></i> {{ $t("nombre") }}</th>
                                                <th><i style="color: white"></i>PLU</th>
                                                <th><i style="color: white"></i> {{ $t("acciones") }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(obj, index) in this.listSubproducts">
                                                <td>{{ obj.name.trim() }}</td>
                                                <td width="20%">
                                                    <input class="form-control" type="text" v-model="obj.newPLU" />
                                                </td>
                                                <td align="center">
                                                    <button v-if="obj.PLU == obj.newPLU" class="btn btn-primary">
                                                        <i class="fa-solid fa-floppy-disk"></i>
                                                    </button>
                                                    <button v-else class="btn btn-warning" @click="changedPLU(obj, 1)">
                                                        <i class="fa-solid fa-floppy-disk"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else class="alert alert-danger m-3" style="width: 100%" role="alert">
                                No se encontraron materias primas sin PLU. Todas las materias primas están configuradas correctamente.
                            </div>
                        </div>
                    </v-tab>
                </vue-tabs>
            </template>
            <template v-else>
                <div class="col-md-12">
                    <div class=" alert alert-primary" align="center">
                        <h3>
                            <i class="fas fa-exclamation-circle"></i>
                            {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
                        </h3>

                        <span>
                            {{ $t("paraMasInformacionContacteConSu") }}
                            <strong>{{ $t("distribuidor") }}</strong>.</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {
    Select,
    Option,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Button,
    Loading,
} from "element-ui";
import swal from "sweetalert2";

export default {
    created() {
        this.loading = Loading.service({ text: "Cargando..." });
        this.$store.dispatch("setNameRoute", this.$i18n.t("productosNoRelacionados"));
        this.tabs = "Productos"
        this.getBusiness();

        this.loading.close();
    }, components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
    }, data() {
        return {
            loading: false,
            tabs: '',
            idBusiness: 0,
            listBusinesses: [],
            query: '',
            listProducts: [],
            listSubproducts: [],
            searchQuery: '',
            searchQuery2: '',
            respuesta: false,
            config98: false,
            config99: false,
            config101: false,
            loadingGeneral: null,
            configTpv: false,
            //tpv
            listTpv: [],
            idsTPV: [],
        };
    }, watch: {
        $route(to, from) {
            if (to.params.query) {
                this.query = to.params.query;
            }

            if (this.tabs == "Productos") {
                this.getProducts(0);
            } else if (this.tabs == "Materias Primas") {
                this.getSubproducts(0);
            }
        }
    }, methods: {

        getBusiness() {
            let config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {
                    vm.listBusinesses = response.data.result;

                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    } else {
                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.getConfigTpv(98);
                    vm.getConfigProductosNoRelacionados();
                    vm.getTpv();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getTpv() {
            this.listTpv = [];
            this.idsTPV = [];

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        for (let i = 0; i < response.data.result.length; i++) {
                            vm.idsTPV.push(response.data.result[i].id)
                        }

                        vm.idTpv = vm.idsTPV[0];

                        for (let i = 0; i < response.data.result.length; i++) {
                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id
                            };

                            vm.listTpv.push(printername)
                        }

                        //RESETEO LAS VARIABLES
                        vm.listProducts = [];

                        if (vm.tabs == "Materias Primas") {
                            vm.getSubproducts(vm.idsTPV[0]);
                        } else if (vm.tabs == "Productos") {
                            vm.getProducts(vm.idsTPV[0]);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getProducts(idTpvTem) {
            const controller = this.searchQuery2
                ? 'gstock/searchProductsByBusinessProductosNoRelacionados/' + this.searchQuery2
                : 'gstock/getProductsProductosNoRelacionados';

            var idTpvSql = idTpvTem != 0 ? idTpvTem : this.idTpv;

            let config = {
                params: {
                    //idBusiness: this.idBusiness,
                    idTpv: idTpvSql,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "integracion/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listProducts = response.data.result;
                        vm.respuesta = true;
                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: this.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });

                        vm.respuesta = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getSubproducts(idTpvTem) {
            const controller = this.searchQuery
                ? 'gstock/searchSubproductsByBusinessProductosNoRelacionados/' + this.searchQuery
                : 'gstock/getSubproductsByBusinessProductosNoRelacionados';

            var idTpvSql = idTpvTem != 0 ? idTpvTem : this.idTpv;

            let config = {
                params: {
                    idTpv: idTpvSql,
                    //idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "integracion/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listSubproducts = response.data.result;
                        vm.respuesta = true;
                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });

                        vm.respuesta = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getConfigTpv(numConfig) {
            let config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: numConfig,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
                .get(this.$store.getters.apiUrl + "general/checkConfigByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        if (numConfig == 98) {
                            vm.config98 = response.data.result
                        } else if (numConfig == 99) {
                            vm.config99 = response.data.result
                        } else if (numConfig == 101) {
                            vm.config101 = response.data.result
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        cambioBusiness() {
            this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

            this.getConfigProductosNoRelacionados();

            this.getTpv();

            this.loadingGeneral.close();
        },

        getConfigProductosNoRelacionados() {

            let configIdentificador = 117;

            let config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idBusiness: this.idBusiness,
                    numConfig: configIdentificador,
                },

                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/checkConfigByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.configTpv = response.data.result;
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: vm.$t("error"),
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        handleTabChange(tabIndex, newTab, oldTab) {
            this.searchQuery = "";
            if (this.tabs == "Materias Primas") {
                this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

                this.getSubproducts(0);
                this.loadingGeneral.close();
            } else if (this.tabs == "Productos") {

                this.getProducts(0);
            }


        },
        searchSubproducts() {
            if (this.searchQuery !== undefined && this.searchQuery !== "") {
                this.$router.push({
                    name: "search-prducto-pnr",
                    params: { query: this.searchQuery },
                });
                //this.isSearch = true;
            }
        },
        removeSearchSubProduct() {
            if (this.searchQuery && this.searchQuery !== "") {
                this.searchQuery = "";
                //  this.isSearch = false;
                this.$router.push({ name: "productosnorelacionados" });
                this.getSubproducts(0);
            }
        },
        searchProducts() {

            console.log("route", this.searchQuery2)
            if (this.searchQuery2 !== undefined && this.searchQuery2 !== "") {
                this.$router.push({
                    name: "search-prducto-pnr",
                    params: { query: this.searchQuery2 },
                });
                //  this.isSearch = true;
            }
        },
        removeSearchProduct() {
            if (this.searchQuery2 && this.searchQuery2 !== "") {
                this.searchQuery2 = "";
                //this.isSearch = false;
                this.$router.push({ name: "productosnorelacionados" });
                this.getProducts(0);
            }
        },
        changedPLU(obj, tipo) {
            let config = {};
            if (tipo == 0) {
                config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idProduct: obj.id,
                        newPLU: obj.newPLU,
                        tipo: tipo,
                        rate: obj.rate,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

            } else {
                config = {
                    params: {

                        idBusiness: this.idBusiness,
                        idProduct: obj.id,
                        newPLU: obj.newPLU,
                        tipo: tipo,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

            }

            let params = {
                idBusiness: this.idBusiness,
                idProduct: obj.id,
                newPLU: obj.newPLU,
                tipo: tipo,
                jwt: this.$store.getters.jwt,
            };
            console.log(params);
            let vm = this;
            let controller = "gstock/updatePLU";
            this.axios
                .post(
                    this.$store.getters.apiUrl + "integracion/" + controller,
                    params,
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        let notify = vm.$t("actualizado");
                        vm.$notify({
                            message:
                                vm.$t("coste") + " " + notify + " " + vm.$t("correctamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });
                        obj.PLU = obj.newPLU;
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        showReplaceConfirmation(tipo) {
            if (tipo == 0) {
                swal.fire({
                    position: "center",
                    title: this.$t('atencion'),
                    type: "warning",
                    text: this.$t('mensajeAviso'),
                    showCloseButton: false,
                    reverseButtons: true,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: this.$t('botonCancelar'),
                    confirmButtonText: this.$t('botonAceptar'),
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',

                }).then((result) => {
                    if (result.value) {
                        this.generateAllPLUs(0);
                    } else if (result.dismiss) {

                    } else if (result.dismiss === swal.DismissReason.close) {
                    }
                });
            } else if (tipo == 1) {
                swal({
                    position: "center",
                    title: this.$t('atencion'),
                    text: this.$t('mensajeAvisoSubProducto'),
                    type: "warning",
                    showCloseButton: false,
                    reverseButtons: true,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: this.$t('botonCancelar'),
                    confirmButtonText: this.$t('botonAceptar'),
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                }).then((result) => {
                    if (result.value) {
                        this.generateAllPLUs(1);
                    } else if (result.dismiss) {

                    } else if (result.dismiss === swal.DismissReason.close) {
                    }
                });
            }

        },
        generateAllPLUs(tipo) {
            const controller = 'gstock/generateAllPLUs'; 
            let config = {};
            if (tipo == 0) {
                config = {
                    params: {
                        idBusiness: this.idBusiness,
                        tipo: tipo,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

            } else {
                config = {
                    params: {
                        idBusiness: this.idBusiness,
                        tipo: tipo,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

            }

            let params = {
                idBusiness: this.idBusiness,
                tipo: tipo,
                jwt: this.$store.getters.jwt,
            };

            let vm = this;
            this.axios.post(this.$store.getters.apiUrl + "integracion/" + controller,params,config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.$notify({
                            message: vm.$t('PLUsGenerados'),
                            type: 'success',
                            timeout: 3000,
                        });
                        vm.getProducts();
                        vm.getSubproducts();
                    } else {
                        vm.$notify({
                            message: response.data.message,
                            type: 'error',
                            timeout: 3000,
                        });
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    vm.$notify({
                        message: vm.$t('errorGenerandoPLUs'),
                        type: 'error',
                        timeout: 3000,
                    });
                });
        },
    },
}
</script>

<style scoped>
a li {
    color: #111;
}

.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}

body {
    background: #1D1F20;
    padding: 16px;
}

.chart-container {
    position: relative;
    margin: auto;
    height: 80vh;
    width: 80vw;
}

.btn-info {
    background-color: #1E22AA;
    
}

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/ProductosNoRelacionados/ProductosNoRelacionados.vue